
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"1","y":"1","width":"18","height":"18"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.667 10c0-4.6 3.724-8.333 8.324-8.333 4.609 0 8.342 3.733 8.342 8.333s-3.733 8.333-8.341 8.333c-4.6 0-8.325-3.733-8.325-8.333zm11.641-3.333h2.459A6.691 6.691 0 0012.158 3.7c.5.925.883 1.925 1.15 2.967zM10 3.367c.691 1 1.233 2.108 1.591 3.3H8.409c.359-1.192.9-2.3 1.592-3.3zM3.333 10c0 .575.083 1.133.217 1.667h2.817c-.067-.55-.117-1.1-.117-1.667s.05-1.117.117-1.667H3.55A6.868 6.868 0 003.333 10zm.9 3.333h2.458c.267 1.042.65 2.042 1.15 2.967a6.656 6.656 0 01-3.608-2.967zm0-6.666h2.458c.267-1.042.65-2.042 1.15-2.967a6.656 6.656 0 00-3.608 2.967zM10 16.633a11.74 11.74 0 01-1.592-3.3h3.184a11.74 11.74 0 01-1.592 3.3zM7.917 10c0 .567.058 1.117.133 1.667h3.9c.075-.55.133-1.1.133-1.667s-.058-1.125-.133-1.667h-3.9c-.075.542-.134 1.1-.134 1.667zm4.241 6.3c.5-.925.883-1.925 1.15-2.967h2.459a6.691 6.691 0 01-3.609 2.967zM13.75 10c0 .567-.05 1.117-.117 1.667h2.817A6.865 6.865 0 0016.666 10c0-.575-.083-1.133-.216-1.667h-2.817c.067.55.117 1.1.117 1.667z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#EFEFEA","fill-opacity":".87","d":"M0 0h20v20H0z"}})])])
          )
        }
      }
    